import { apiPost } from "../ApiMethod";

export const loginCallback = async (data) => {
  const response = await apiPost("_login", data);
  return { ...response };
};